import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import {
  frentistaDao,
  combustivelDao,
  cashpostoDao,
  empresaDao,
  cobrancaDao,
  compraDao,
  voucherDao,
  carteiraVirtualDao,
  tipoPagamentoDao,
  pessoaDao,
  meioPagamentoDao,
  pagPixBankDao,
  funcionarioDao,
  itemDao,
  assinaturaDao,
  veiculoDao
} from '@/api'

Vue.use(Vuex)

// TODO: Colocar a pessoa como filho do usuario e o endereco como filho da pessoa
export default new Vuex.Store({
  state: {
    user: null,
    cliente: null,
    veiculo: null,
    usuario_beneficiado: null,
    senhaPin: null,
    senhaClientePlaca: null,
    vouchers: [],
    compras: [],
    creditos: [],
    reservas: [],
    caixa: [],
    frentistas: [],
    frentista: null,
    combustiveis: {},
    cobrancas: { cobs: [], parametros: { paginacao: { quantidadeTotalDeItens: 10 } } },
    loading: false,
    error: null,
    qrcodeCobranca: null,
    success: null,
    headers: null,
    voucherSelected: null,
    voucherSelectedPlaca: null,
    interval: 0,
    vouchersPremio: [],
    vouchersFuncionario: [],
    historyVouchers: {
      results: [],
      count: 0
    },
    hasNewVersion: false,
    versao: localStorage.getItem(`apetrus-frentista-versao`)
  },
  mutations: {
    setAuthHeader (state, payload) {
      state.headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${payload}`
      })
    },
    setUser (state, payload) {
      state.user = payload
    },
    setCliente (state, payload) {
      state.cliente = payload
    },
    setVeiculo (state, payload) {
      state.veiculo = payload
    },
    setUsuario_beneficiado (state, payload) {
      state.usuario_beneficiado = payload
    },
    setUserImage (state, payload) {
      state.user.image = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setLastPage (state, payload) {
      if (state.user) {
        localStorage.setItem(`cliente-${state.user.id}`, payload)
      }
      state.lastPage = payload
    },
    addVoucher (state, payload) {
      let vouchers = state.historyVouchers
      vouchers.results = [payload].concat(state.historyVouchers.results)
      vouchers.results.pop()
      vouchers.count += 1

      state.historyVouchers = { ...vouchers }
    },
    setError (state, payload) {
      state.error = payload
    },
    setVouchers (state, payload) {
      state.vouchers = payload
    },
    setCompras (state, payload) {
      state.compras = payload
    },
    setReservas (state, payload) {
      state.reservas = payload
    },
    setCobrancas (state, payload) {
      state.cobrancas = payload
    },
    setQrcodeCobranca (state, payload) {
      state.qrcodeCobranca = payload
    },
    /** vouche set I want to use
     *
     *
     * @param  {} state
     * @param  {} payload
     */
    setSuccess (state, payload) {
      state.success = payload
    },
    setSuccessPin (state, payload) {
      state.success = payload
    },
    setHistoryVouchers (state, payload) {
      state.historyVouchers = payload
    },
    setSenhaPin (state, payload) {
      state.voucherSelected = { ...state.voucherSelected, senhaPin: payload }
    },
    /** this set pin function of the gas station attendant
     *
     *
     * @param  {} state
     * @param  {} payload
     */
    setPinFretista (state, payload) {
      state.voucherSelectedPlaca = {
        ...state.voucherSelectedPlaca,
        senhaPin: payload
      }
    },
    setCaixa (state, payload) {
      state.caixa = payload
    },
    setCombustiveis (state, payload) {
      state.combustiveis = payload
    },
    setFrentistas (state, payload) {
      state.frentistas = payload
    },
    setFrentista (state, payload) {
      state.frentista = payload
    },
    setVouchersPremio (state, payload) {
      state.vouchersPremio = payload
    },
    setVoucherFuncionario (state, payload) {
      state.vouchersFuncionario = payload
    },
    setHasNewVersion (state, payload) {
      state.hasNewVersion = payload
    },
    setVersao (state, payload) {
      state.versao = payload
    },
    setCreditos (state, payload) {
      state.creditos = payload
    }
  },
  actions: {
    autenticar ({ commit }, payload) {
      commit('setSenhaPin', payload)
    },
    addVoucherHistory ({ commit, state }, payload) {
      commit('addVoucher', payload)
    },
    vincularCupomFiscal ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao
          .adicionarCupom(
            payload.cupom_model,
            payload.id_voucher,
            state.headers
          )
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              commit('setError', {
                message: 'Desculpe, não foi possível confirmar o abastecimento'
              })
              reject(
                new Error(
                  'Desculpe, não foi possí­vel confirmar o abastecimento'
                )
              )
            } else {
              commit('setSuccess', {
                message: 'O abastecimento foi confirmado com sucesso!',
                title: 'Parabéns'
              })
              resolve(payload)
            }
          })
      })
    },
    carregarCaixa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        voucherDao
          .historyCaixa(state.headers, payload)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(Error('Não foi possível carregar Histórico do Caixa'))
            }
            return response.json()
          })
          .then((json) => {
            commit('setLoading', false)
            commit('setCaixa', json.vouchers)
            resolve(json)
          })
      })
    },
    editarCupomFiscal ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao
          .editarCupom(payload.cupom_model, payload.id_voucher, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              commit('setError', {
                message: 'Desculpe, não foi possível submeter o novo cupom'
              })
              reject(
                new Error('Desculpe, não foi possível submeter o novo cupom')
              )
            } else {
              commit('setSuccess', {
                message: 'O novo cupom foi submetido com sucesso!',
                title: 'Parabéns'
              })
              resolve(payload)
            }
          })
      })
    },
    cancelarAbastecimentoVoucher ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao
          .cancelarAbastecimentoVoucher(payload.id_voucher, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              commit('setError', {
                message: 'Desculpe, não foi possível cancelar o abastecimento'
              })
              reject(
                new Error('Desculpe, não foi possível cancelar o abastecimento')
              )
            } else {
              commit('setSuccess', {
                message: 'O abastecimento foi cancelado com sucesso!',
                title: 'Parabéns'
              })
              resolve(payload)
            }
          })
      })
    },
    cleanHistory ({ commit }) {
      commit('setHistoryVouchers', {
        results: [],
        count: 0
      })
    },
    carregarHistoryVouchers ({ commit, state }, payload) {
      if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
      else payload.empresa = state.user.frentista.empresa.cnpj
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        voucherDao.historyVouchers(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', {
              message:
                'Desculpe, não conseguimos retornar o histórico de vouchers do frentista'
            })
            reject(Error('Não foi possível retornar o histórico de Vouchers'))
          } else {
            return response.json()
          }
        }).then((json) => {
          commit('setHistoryVouchers', json)
          resolve(json)
        })
      })
    },
    setSuccess ({ commit }, payload) {
      commit('setSuccess', payload)
    },
    setSuccessPin ({ commit }, payload) {
      commit('setSuccessPin', payload)
    },
    setError ({ commit }, payload) {
      commit('setError', payload)
    },
    clean ({ commit }) {
      commit('setVouchers', [])
      commit('setCompras', [])
      commit('setReservas', [])
      commit('setCliente', null)
      commit('setVeiculo', null)
      commit('setVouchersPremio', [])
      commit('setVoucherFuncionario', [])
    },
    usarVoucher ({ commit, state }, payload) {
      commit('setLoading', true)
      voucherDao
        .useVoucher(
          payload.cpf,
          payload.id_voucher,
          payload.senhaPin,
          payload.frentista,
          payload.hodometro,
          state.headers
        )
        .then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', {
              message:
                'Desculpe, não foi possível utilizar o voucher selecionado'
            })
            commit('setSenhaPin', null)
          } else {
            commit('setSuccess', {
              message: 'O Voucher foi utilizado com sucesso!',
              title: 'Parabéns'
            })
            this.dispatch('clean')
          }
        })
    },
    realizarleituraVoucher ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao.realizarLetura(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', {
              message:
                'Desculpe, não foi possível realizar leitura do voucher selecionado'
            })
            reject(new Error('Não foi possível realizar leitura do voucher'))
          } else {
            commit('setSuccess', {
              message: 'O Voucher foi utilizado com sucesso!',
              title: 'Parabéns'
            })
            resolve('ok')
          }
        })
      })
    },
    autenticarPin ({ commit, state }, payload) {
      commit('setLoading', true)
      console.log(state.user.frentista)
      if (state.user.frentista.posto) payload.cnpj = state.user.frentista.posto.cnpj
      else payload.empresa = state.user.frentista.empresa.cnpj
      return new Promise((resolve, reject) => {
        frentistaDao.AutenticarPin(
          state.headers,
          payload
        ).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            if (response.status === 404) {
              commit('setError', {
                message:
                  'Desculpe, esse frentista ainda não possui um PIN cadastrado'
              })
            } else {
              commit('setError', {
                message: 'Desculpe, não foi possível autenticar seu PIN'
              })
            }
            reject(Error('Não foi possível autenticar'))
          } else {
            if (payload.tipoAbastecimento === 'cpf') {
              commit('setSenhaPin', payload.pin)
            } else if (payload.tipoAbastecimento === 'placa') {
              commit('setPinFretista', payload.pin)
            }
            resolve('OK')
          }
        })
      })
    },
    /**
     * this set function asks Vue to post to use the Voucher
     *
     *
     * @param  {} {commit
     * @param  {} state}
     * @param  {} payload
     */
    usarVoucherPlaca ({ commit, state }, payload) {
      commit('setLoading', true)
      voucherDao
        .useVoucherPlaca(
          payload.placa,
          payload.id_voucher,
          payload.senhaPin,
          payload.frentista,
          payload.hodometro,
          state.headers
        )
        .then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', {
              message:
                'Desculpe, não foi possí­vel utilizar o voucher selecionado'
            })
            commit('setSenhaPin', null)
          } else {
            commit('setSuccess', {
              message: 'O Voucher foi utilizado com sucesso!',
              title: 'Parabéns'
            })
            this.dispatch('clean')
          }
        })
    },
    lookupVouchers ({ commit, state }, payload) {
      commit('setLoading', true)
      voucherDao
        .listVouchers(payload, state.headers)
        .then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', {
              message:
                'Desculpe, não conseguimos retornar os vouchers do cliente'
            })
            return new Error('Não foi possí­vel retornar os Vouchers')
          } else {
            return response.json()
          }
        })
        .then((json) => {
          commit('setCliente', json.cliente)
          commit('setCompras', json.compras)
          commit('setReservas', json.reservas)
          commit('setVouchersPremio', json.voucherpremio)
          commit('setVoucherFuncionario', json.voucherfuncionario)
        })
    },
    /**
     * this function takes the vouchers available with that car
     *
     * @param  {} {commit
     * @param  {} state}
     * @param  {} payload
     */
    lookupVouchersPlaca ({ commit, state }, payload) {
      commit('setLoading', true)
      if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
      else payload.empresa = state.user.frentista.empresa.cnpj
      voucherDao
        .listVouchersplaca(payload, state.headers)
        .then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', {
              message:
                'Desculpe, não conseguimos retornar os vouchers do cliente'
            })
            return new Error('Não foi possí­vel retornar os Vouchers')
          } else {
            return response.json()
          }
        })
        .then((json) => {
          commit('setVeiculo', json.veiculo)
          commit('setCompras', json.compras)
          commit('setVoucherFuncionario', json.voucherfuncionario)
          commit('setCreditos', json.creditos)
        })
    },
    login ({ commit, state }, payload) {
      frentistaDao
        .login(state.headers)
        .then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            if (response.status === 403) {
              commit('setError', {
                message:
                  'Desculpe, houve uma falha no seu cadastro, por favor, tente novamente mais tarde'
              })
            } else if (response.status === 400) {
              commit('setError', {
                message:
                  'Esse usuário atualmente está bloqueado em nosso sitema, para mais informações, entre em contato com a Apetrus'
              })
            }
            this.dispatch('signUserOut')
          } else {
            return response.json()
          }
        })
        .then((json) => {
          commit('setFrentista', json)
          let lastpage = localStorage.getItem(`frentista-${json.id_frentista}`)
          if (lastpage) {
            commit('setLastPage', lastpage)
          }
          payload = { ...payload, frentista: json }
          commit('setUser', payload)
          this.dispatch('renovarToken')
          let storage = firebase.storage()
          storage
            .ref(`users/avatars/${payload.id}.png`)
            .getDownloadURL()
            .then((imageUrl) => {
              commit('setUserImage', imageUrl)
            })
            .catch((error) => {
              console.log('erro', error)
            })
        })
    },
    signUserOut ({ commit, state }) {
      commit('setLoading', true)
      firebase
        .auth()
        .signOut()
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          console.log(errorCode)
          console.log(errorMessage)
        })
      clearInterval(state.interval)
    },
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      return firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(() => {
          commit('setLoading', false)
          return true
        })
        .catch((error) => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    async renovarToken ({ commit, state }) {
      let diference
      var expirationTime
      var issuedAtTime
      if (state.user != null) {
        await firebase
          .auth()
          .currentUser.getIdTokenResult(true)
          .then((result) => {
            expirationTime = Date.parse(result.expirationTime)
            issuedAtTime = Date.parse(result.issuedAtTime)
            diference = (expirationTime - issuedAtTime) / 1000 / 2
            diference = diference.toFixed(0)
          })
        state.interval = setInterval(() => {
          diference--
          if (diference === 0) {
            firebase
              .auth()
              .currentUser.getIdToken(true)
              .then((token) => {
                commit('setAuthHeader', token)
              })
            firebase
              .auth()
              .currentUser.getIdTokenResult(true)
              .then((result) => {
                var expirationTime
                var issuedAtTime
                expirationTime = Date.parse(result.expirationTime)
                issuedAtTime = Date.parse(result.issuedAtTime)
                diference = (expirationTime - issuedAtTime) / 1000 / 2
                diference = diference.toFixed(0)
              })
          }
        }, 1000)
      }
    },
    userChanged ({ commit, state }, payload) {
      const user = payload
      commit('setLoading', false)
      if (user) {
        const newUser = {
          id: user.uid,
          email: user.email,
          emailVerified: user.emailVerified,
          image: null
        }
        user.getIdToken().then((token) => {
          if (!state.user) {
            commit('setAuthHeader', token)
            this.dispatch('login', newUser)
          }
        })
      } else {
        commit('setUser', null)
        commit('setAuthHeader', null)
        commit('setLastPage', null)
      }
      // incluir os demais atributos que o usuário pode ter
      // Como postos que administra, perfil de cliente e perfil de frentista
    },
    sendVerifyEmail ({ commit }) {
      commit('setLoading', true)
      return new Promise((resolve) => {
        firebase
          .auth()
          .currentUser.sendEmailVerification()
          .then((response) => {
            commit('setLoading', false)
            resolve(response)
          })
          .catch((error) => {
            commit('setLoading', false)
            commit('setError', error)
          })
      })
    },
    loadCombustiveis ({ commit }) {
      return new Promise((resolve, reject) =>
        combustivelDao
          .get()
          .then((response) => {
            return response.json()
          })
          .then((json) => {
            let combustiveis = {}
            json.forEach((comb) => {
              combustiveis[comb.id_combustivel] = { ...comb }
            })
            commit('setCombustiveis', combustiveis)
            resolve(combustiveis)
          })
      )
    },
    cadastrarPreco ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        combustivelDao
          .cadastrarPreco(payload, state.headers)
          .then((response) => {
            if (response.ok) {
              resolve()
            } else {
              if (response.status === 422) {
                reject(
                  new Error(
                    'O preço na bomba só pode ser alterado uma vez por dia, tente novamente amanhã.'
                  )
                )
              } else {
                reject(new Error('Não foi possível cadastrar preço'))
              }
            }
          })
      })
    },
    carregarItens ({ commit, state }) {
      commit('setLoading', true)
      if (!state.user.frentista.posto && !state.user.frentista.empresa) {
        commit('setLoading', false)
        return
      }
      const data = {
        parameters: {
          categoria__referencia: 'combustivel',
          combustivel__isnull: false,
          frentista: state.frentista.id_frentista
        },
        method: 'GET'
      }
      if (state.user.frentista.posto) data.posto = state.user.frentista.posto.cnpj
      else data.empresa = state.user.frentista.empresa.cnpj
      return new Promise((resolve, reject) =>
        itemDao.item(state.headers, data)
          .then((response) => {
            commit('setLoading', false)
            return response.json()
          })
          .then((json) => {
            let combustiveis = state.combustiveis
            json.forEach((item) => {
              combustiveis[item.combustivel.id_combustivel] = {
                ...combustiveis[item.combustivel.id_combustivel],
                item: item
              }
            })
            commit('setCombustiveis', combustiveis)
            resolve(json)
          }).catch(() => {
            reject(Error('Não foi possível pegar itens'))
          })
      )
    },
    cadastrarOuAlterarItem ({ commit, state }, payload) {
      commit('setLoading', true)
      if (!state.user.frentista.posto && !state.user.frentista.empresa) {
        commit('setLoading', false)
        return
      }
      return new Promise((resolve, reject) => {
        itemDao.item(state.headers, payload).then(response => {
          commit('setLoading', false)
          return response.json()
        }).then(json => {
          if (payload.method === 'POST') {
            commit('setSuccess', 'Preço cadastrado com sucesso')
          } else {
            commit('setSuccess', 'Alterado cadastrado com sucesso')
          }
          this.dispatch('carregarItens')
          resolve(json)
        }).catch(error => {
          console.error(error)
          reject(error)
        })
      })
    },
    listarFrentistas ({ commit, state }) {
      const data = {}
      if (state.user.frentista.posto) data.posto = state.user.frentista.posto.cnpj
      else data.empresa = state.user.frentista.empresa.cnpj
      return new Promise((resolve, reject) => {
        frentistaDao
          .listaFrentistas(data, state.headers)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else {
              reject(new Error('Não foi possível listar os frentistas!'))
            }
          })
          .then((json) => {
            commit('setFrentistas', json)
          })
      })
    },
    listarCobrancas ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) {
          data.posto = state.user.frentista.posto.cnpj
          data.vendedor = 1
        } else {
          data.empresa = state.user.frentista.empresa.cnpj
          data.vendedor = 2
        }
        cobrancaDao.getCobrancas(state.headers, data)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else {
              reject(new Error('Não foi possível listar as cobranças!'))
            }
          })
          .then((json) => {
            commit('setCobrancas', json)
            resolve(json)
          })
      })
    },
    inserirFrentista ({ commit, state }, frentista) {
      var body = frentista.id_pessoa
        ? {
          id_pessoa: frentista.id_pessoa,
          matricula: frentista.matricula
        }
        : frentista
      if (state.user.frentista.posto) body.posto = state.user.frentista.posto.cnpj
      else body.empresa = state.user.frentista.empresa.cnpj
      return new Promise((resolve, reject) => {
        frentistaDao.inserirFrentista(body, state.headers).then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              commit('addFrentista', json)
              resolve(json)
            })
          } else {
            response.text().then((e) => {
              reject(e)
            })
          }
        })
      })
    },
    inserirCobranca ({ commit, state }, body) {
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) {
          body.posto = state.user.frentista.posto.cnpj
          body.vendedor = 1
        } else {
          body.empresa = state.user.frentista.empresa.cnpj
          body.vendedor = 2
        }
        commit('setLoading', true)
        cobrancaDao.criarCobranca(body, state.headers).then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              commit('setQrcodeCobranca', json.imagemQrcode)
              commit('setLoading', false)
              resolve(json)
            })
          } else {
            response.text().then((e) => {
              reject(e)
            })
          }
        })
      })
    },
    cadastrarPin ({ commit, state }, payload) { // remover
      return frentistaDao
        .cadastrarPin(payload.cnpj, payload.pin, payload.id, state.headers)
        .then((response) => {
          if (!response.ok) {
            commit('setError', {
              message: 'Desculpe, não foi possível cadastrar seu PIN'
            })
          } else {
            commit('setSuccess', {
              message: 'PIN cadastrado com sucesso!',
              title: 'Parabéns'
            })
          }
          return response.status
        })
    },
    programaIncentivo ({ commit, state }, payload) {
      return frentistaDao
        .programaIncentivo(payload, state.headers)
        .then((response) => {
          if (!response.ok) {
            commit('setError', { message: 'Ocorreu algum erro' })
          } else {
            commit('setSuccess', {
              message: 'Cadastrado com sucesso',
              title: 'Parabéns'
            })
            this.dispatch('listarFrentistas')
          }
        })
    },
    solicitarRetirada ({ commit, state }, payload) {
      return frentistaDao
        .solicitarRetirada(payload, state.headers)
        .then((response) => {
          if (!response.ok) {
            commit('setError', {
              message:
                'Não é possível solicitar retirada de um valor inferior a R$ 100,00 ou fora do período estipulado'
            })
          } else {
            commit('setSuccess', {
              message: 'Solicitado com sucesso',
              title: 'Parabéns'
            })
            this.dispatch('listarFrentistas')
          }
        })
    },
    detalhesFrentista ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao
          .detalhesfrentista(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi encontrado os dados desse frentista'))
            } else {
              resolve(response.json())
            }
          })
      })
    },
    getSolicitacoes ({ state, commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        frentistaDao
          .getSolicitacoes(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Ocorreu um erro'))
            } else {
              resolve(response.json())
            }
          })
      })
    },
    comprasEmDinheiro ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.cnpj = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        compraDao
          .comprasEmDinheiro(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível carregar compras'))
            } else {
              resolve(response.json())
            }
          })
      })
    },
    lerEmEspecie ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        compraDao
          .leituraCompraDinheiro(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              commit('setError', {
                message: 'Desculpe, não foi possível realizar leitura!'
              })
              reject(new Error('Não foi possível realizar leitura'))
            } else {
              commit('setSuccess', {
                message: 'Leitura realizada!',
                title: 'Parabéns'
              })
              resolve('ok')
            }
          })
      })
    },
    darBaixarEmTodos ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        compraDao
          .darBaixarEmTodos(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              commit('setError', {
                message: 'Desculpe, não foi possível realizar leitura!'
              })
              reject(new Error('Não foi possível realizar leitura'))
            } else {
              commit('setSuccess', {
                message: 'Leitura realizada!',
                title: ''
              })
              resolve('ok')
            }
          })
      })
    },
    confirmarMatricula ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        frentistaDao
          .confirmarMatricula(payload, state.headers)
          .then((response) => {
            if (!response.ok) {
              commit('setError', {
                message:
                  'Não existe um gerente de pista com esse e-mail ou matrícula, por favor, entre em contato com o posto. '
              })
              reject(new Error('Frentista não encontrado'))
            } else {
              commit('setSuccess', {
                message: 'Cadastre agora sua senha.',
                title: 'Parabéns'
              })
              resolve('ok')
            }
          })
      })
    },
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(() => {
            this.dispatch('sendVerifyEmail')
            commit('setSuccess', {
              message:
                'Você receberá um e-mail de verificação. Confira seu e-mail',
              title: 'Acesso autorizado'
            })
            resolve('ok')
          })
          .catch((error) => {
            console.log(error)
            commit('setLoading', false)
            commit('setError', {
              message:
                'Esse e-mail já está em uso. Entre em contato com o posto.'
            })
            reject(error)
          })
      })
    },
    lerVoucherPremio ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        voucherDao
          .lerVoucherPremio(payload, state.headers)
          .then((response) => {
            if (response.ok) {
              commit('setSuccess', {
                message: 'Leitura Realizada com sucesso',
                title: ''
              })
              this.dispatch('clean')
              resolve('ok')
            } else {
              commit('setError', {
                message: 'Não foi possível realizar leitura'
              })
              reject(new Error('Não foi possível realizar leitura'))
            }
          })
      })
    },
    pegarVoucherPremio ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        voucherDao
          .voucherPremio(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi encontrado prêmios retirados'))
            } else {
              resolve(response.json())
            }
          })
      })
    },
    redefinirPin ({ state, commit }, payload) { // remover
      return frentistaDao
        .redefinirPin(payload, state.headers)
        .then((response) => {
          if (!response.ok) {
            commit('setError', {
              message: 'Desculpe, não foi possível redefinir seu PIN.'
            })
          } else {
            commit('setSuccess', {
              message: 'PIN redefinido com sucesso!',
              title: 'Parabéns'
            })
          }
          return response.status
        })
    },
    verificarAtualizacao ({ commit }, payload) {
      var version = localStorage.getItem(`${payload.name}-versao`)
      if (version !== payload.version) {
        commit('setHasNewVersion', true)
      }
    },
    atualizarVersao ({ commit }, payload) {
      localStorage.setItem(`${payload.name}-versao`, payload.version)
      commit('setVersao', payload.version)
    },
    cancelarCompra ({ state, commit }, payload) {
      // Cancelar compra em espécie
      return new Promise((resolve, reject) => {
        compraDao.cancelarCompra(payload, state.headers).then((response) => {
          if (!response.ok) {
            commit('setError', { message: 'Não foi possível cancelar compra' })
            reject(new Error('Não foi possível cancelar compra'))
          } else {
            commit('setSuccess', { message: 'Compra cancelada com sucesso' })
            resolve('Compra cancelada com sucesso')
          }
        })
      })
    },
    historicoCash ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        cashpostoDao.pegarHistorico(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: 'Não foi possível pegar histórico' })
            reject(new Error('Não foi possível pegar histórico'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    historicoEmpresa ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        empresaDao.pegarHistoricoEmpresa(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: 'Não foi possível pegar histórico' })
            reject(new Error('Não foi possível pegar histórico'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    sendResetEmail ({
      commit
    }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        firebase.auth().sendPasswordResetEmail(payload).then((response) => {
          commit('setLoading', false)
          commit('setSuccess', { message: 'Email enviado com sucesso.' })
          resolve(response)
        }).catch((error) => {
          commit('setLoading', false)
          commit('setError', { message: 'Não foi possível enviar email.' })
          reject(error)
        })
      })
    },
    pegarCompra ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        compraDao.pegarPorCodigo(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: 'Não foi possível encontrar uma compra com esse código.' })
            reject(new Error('Não foi possível encontrar uma compra com esse código.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    realizarLeitura ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao.realizarLeturaCodigo(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: 'Não foi possível encontrar uma compra com esse código.' })
            reject(new Error('Não foi possível encontrar uma compra com esse código.'))
          } else {
            commit('setSuccess', { message: 'Leitura realizada com sucesso.' })
            resolve('ok')
          }
        })
      })
    },
    mudarFrentista ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        commit('setLoading', false)
        commit('setFrentista', payload)
        resolve('ok')
      })
    },
    voucherPremio ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        voucherDao.pegarVoucherPremio(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: `Não foi encontrado nenhum prêmio ${payload.codigo ? 'com esse código' : 'para esse cliente'}.` })
            reject(new Error('Não foi encontrado nenhum prêmio com esse código.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    cashPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!payload || !payload.method) reject(new Error('Method não enviado'))
        voucherDao.cashPosto(state.headers, payload.data, payload.method).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            if (payload.method === 'GET') commit('setError', { message: `Não foi encontrado nenhum cash posto ${payload.data.numero ? 'com esse código' : 'para esse cliente'}.` })
            else commit('setError', { message: 'Não foi possível realizar leitura' })
            reject(new Error('Ocorreu um erro.'))
          } else {
            if (payload.method === 'GET') resolve(response.json())
            commit('setSuccess', { message: 'Leitura realizada com sucesso.' })
            resolve('ok')
          }
        })
      })
    },
    comprarCashPosto ({ commit, state }, payload) {
      if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
      else payload.empresa = state.user.frentista.empresa.cnpj
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        carteiraVirtualDao.comprarCashPosto(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: `Não foi possível compra Cash Posto.` })
            reject(new Error('Não foi possível compra Cash Posto.'))
          } else {
            commit('setSuccess', { message: `Compra realizada com sucesso.` })
            resolve('ok')
          }
        })
      })
    },
    pegarTiposDePagamento ({ commit, state }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        tipoPagamentoDao.get().then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar tipos de pagamento.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    pegarPessoaPorId ({ commit, state }, payload) {
      if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
      else payload.empresa = state.user.frentista.empresa.cnpj
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        pessoaDao.pegarPorId(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar pessoa.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    pegarComprasCashPosto ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        compraDao.pegarComprasCashPosto(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar compras de cash.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    pegarMeiosDePagamentosSecundarios ({ commit, state }) {
      const payload = {}
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        meioPagamentoDao.pegarMeiosSecundarios(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar compras de cash.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    transacoesPagPixBank ({ commit, state }, payload) {
      if (state.user.frentista.posto) payload.cnpj_posto = state.user.frentista.posto.cnpj
      else payload.cnpj_empresa = state.user.frentista.empresa.cnpj
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (!payload || !payload.method) reject(new Error('Method não enviado'))
        pagPixBankDao.transacoes(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            if (payload.method === 'POST') commit('setError', { message: 'Não foi possível gerar QRcode.' })
            if (payload.method === 'DELETE') commit('setError', { message: 'Não foi possível cancelar transação' })
            reject(new Error('Ocorreu um erro.'))
          } else {
            return response.json()
          }
        }).then(json => {
          if (payload.method === 'POST') {
            const imagemDecode = `data:image/png;base64,${json.pagamentoQrCode}`
            commit('setQrcodeCobranca', imagemDecode)
          }
          if (payload.method === 'DELETE') commit('setError', { message: 'Não foi possível cancelar transação' })
          commit('setLoading', false)
          resolve(json)
        })
      })
    },
    pegarFuncionarios ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        funcionarioDao.get(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar funcionarios.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    gerarVoucherComCredito ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        voucherDao.gerarVoucherComCredito(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: `Não possível realizar leitura` })
            reject(new Error('Não foi possível gerar voucher.'))
          } else {
            commit('setSuccess', { message: `Leitura Realizada com Sucesso.` })
            resolve('ok')
          }
        })
      })
    },
    editarFrentista ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        frentistaDao.editar(payload, state.headers).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            commit('setError', { message: `Não possível realizar a operação` })
            reject(new Error('Não possível realizar a alteração.'))
          } else {
            commit('setSuccess', { message: `Operação realizada com sucesso.` })
            resolve('ok')
          }
        })
      })
    },
    gereciarAssinatura ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) {
          if (payload.method === 'GET') {
            payload.parametros.posto = state.user.frentista.posto.cnpj
          } else payload.body.posto = state.user.frentista.posto.cnpj
        } else {
          if (payload.method === 'GET') {
            payload.parametros.empresa = state.user.frentista.empresa.cnpj
          } else payload.body.empresa = state.user.frentista.empresa.cnpj
        }
        assinaturaDao.gerenciar(state.headers, payload).then((response) => {
          commit('setLoading', false)
          let message = ''
          if (!response.ok) {
            if (payload.method === 'PUT') message = 'Não foi possível pagar assinatura.'
            else if (payload.method === 'POST') message = 'Não foi possível realizar assinatura.'
            else if (payload.method === 'DELETE') message = 'Não foi possível cancelar assinatura.'
            if (message) commit('setError', { message })
            reject(new Error(message))
          } else {
            if (payload.method === 'PUT') message = 'Pagamento da Assinatura Realizado com Sucesso.'
            else if (payload.method === 'POST') message = 'Assinatura Realizada com Sucesso.'
            else if (payload.method === 'DELETE') message = 'Assinatura Cancelada com Sucesso.'
            if (message) commit('setSuccess', { message })
            resolve(
              payload.method === 'GET' ? response.json() : 'ok'
            )
          }
        })
      })
    },
    pegarPlanos ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.cnpj = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        assinaturaDao.pegarPlanos(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível pegar funcionarios.'))
          } else {
            resolve(response.json())
          }
        })
      })
    },
    pagamentosDeAssinatura ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        compraDao
          .deAssinatura(payload, state.headers)
          .then((response) => {
            commit('setLoading', false)
            if (!response.ok) {
              reject(new Error('Não foi possível carregar pagamentos de assinatura'))
            } else {
              resolve(response.json())
            }
          })
      })
    },
    pegarVeiculosAssinatura ({ commit, state }, payload) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        if (state.user.frentista.posto) payload.posto = state.user.frentista.posto.cnpj
        else payload.empresa = state.user.frentista.empresa.cnpj
        veiculoDao.pegarPorAssinatura(state.headers, payload).then((response) => {
          commit('setLoading', false)
          if (!response.ok) {
            reject(new Error('Não foi possível carregar veiculos'))
          } else {
            resolve(response.json())
          }
        })
      })
    }
  },
  getters: {
    error (state) {
      return state.error
    },
    senhaPin (state) {
      return state.voucherSelected ? state.voucherSelected.senhaPin : null
    },
    /**
     * This function takes the current state of the pin attendant
     *
     * @param  {} state
     */
    senhaClientePlaca (state) {
      return state.voucherSelectedPlaca
        ? state.voucherSelectedPlaca.senhaPin
        : null
    },
    historyVouchers (state) {
      return state.historyVouchers
    },
    success (state) {
      return state.success
    },
    voucherSelected (state) {
      return state.voucherSelected
    },
    voucherSelectedPlaca (state) {
      return state.voucherSelectedPlaca
    },
    vouchers (state) {
      return state.vouchers
    },
    compras (state) {
      return state.compras
    },
    reservas (state) {
      return state.reservas
    },
    cliente (state) {
      return state.cliente
    },
    veiculo (state) {
      return state.veiculo
    },
    cobrancas (state) {
      return state.cobrancas
    },
    qrcodecobranca (state) {
      return state.qrcodeCobranca
    },
    usuario_beneficiado (state) {
      return state.usuario_beneficiado
    },
    user (state) {
      return state.user
    },
    frentista (state) {
      return state.user ? state.user.frentista : null
    },
    frentistaSelecionado (state) {
      return state.frentista
    },
    posto (state) {
      return state.user && state.user.frentista
        ? state.user.frentista.posto
        : null
    },
    empresa (state) {
      return state.user && state.user.frentista
        ? state.user.frentista.empresa
        : null
    },
    frentistas (state) {
      return state.frentistas
    },
    loading (state) {
      return state.loading
    },
    caixa (state) {
      return state.caixa
    },
    combustiveis (state) {
      return state.combustiveis
    },
    headers (state) {
      return state.headers
    },
    vouchersPremio (state) {
      return state.vouchersPremio
    },
    /**
     * function that getters employees vouchers.
     *
     */
    vouchersFuncionario (state) {
      return state.vouchersFuncionario
    },
    hasNewVersion (state) {
      return state.hasNewVersion
    },
    versao (state) {
      return state.versao
    },
    creditos (state) {
      return state.creditos
    }
  }
})
